import { SecuredClient } from '../../../Core/Api/SecuredClient';

export interface FormState {
    title: string;
    message: string;
    sendToAll: boolean;
    userIdsInput: string;
}

export class NotificationHandler {
    async sendNotification(
        recipientUserIds: string[],
        sendToAll: boolean,
        title: string,
        message: string
    ): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        try {
            const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/SendNotification`;
            const content = JSON.stringify({ recipientUserIds, sendToAll, title, message });
            const response = await client.axiosInstance.request({
                data: content,
                method: 'POST',
                url,
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Accept': 'text/plain',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error sending notification:', error);
            throw error;
        }
    }
}
